export default "__VITE_PUBLIC_ASSET__d277fea0__"